import { createRouter, createWebHistory } from 'vue-router';

const Home = () => import('@/core/home/home.vue');
const Error = () => import('@/core/error/error.vue');
import account from '@/router/account';
import admin from '@/router/admin';
import entities from '@/router/entities';
import pages from '@/router/pages';

// Note vue-router 4 : la navigation en double (push vers l'URL courante) résout avec un
// NavigationFailure au lieu de rejeter → le patch Router.prototype d'avant n'est plus nécessaire.
// Les guards in-component (beforeRouteEnter/Leave/Update) sont natifs en Options API → plus de registerHooks.

// prettier-ignore
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Error,
      meta: { error403: true }
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: Error,
      meta: { error404: true }
    },
    ...account,
    ...admin,
    entities,
    ...pages
  ]
});

router.beforeEach((to, from, next) => {
  const spaceId = to.params.spaceId;
  if (spaceId !== undefined && (!spaceId || spaceId === 'none')) {
    return next({ path: '/', query: { missingSpace: '1' } });
  }
  next();
});

export default router;
